export type PipelineMapOperatorDirectoryEntry = {
  operatorId: string
  name?: string | null
}

/** Same branching as legacy `Map.js` (ZOHO id in downloads vs company name when ZOHO absent). */
export function resolvePipelineViewOperatorTarget(
  featureProps: Record<string, unknown>,
  directory: readonly PipelineMapOperatorDirectoryEntry[],
): string | null {
  const rawZ = featureProps.ZOHO_OPERA ?? featureProps.Zoho_Opera ?? featureProps.zoho_opera
  let zohoId: string | null = null
  if (typeof rawZ === 'string' && rawZ.trim()) zohoId = rawZ.trim()
  else if (typeof rawZ === 'number' && Number.isFinite(rawZ)) zohoId = String(Math.trunc(rawZ))

  if (zohoId && directory.some((d) => d.operatorId === zohoId)) return zohoId

  const rawCo = featureProps.CO_NAME ?? featureProps.co_name
  const companyName =
    typeof rawCo === 'string' && rawCo.trim() ? rawCo.trim() : null

  if (!zohoId && companyName) {
    const hit = directory.find(
      (d) =>
        !!d.name &&
        typeof d.name === 'string' &&
        d.name.toLowerCase().includes(companyName.toLowerCase()),
    )
    return hit?.operatorId ?? null
  }

  return null
}
